import React, { Component } from 'react';

class Header extends Component {
    render(){
        return(
            <header className="header">
                <h1>
                    Emoji Search
                </h1>
            </header>
        );
    }
}

export default Header 